/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * The API error code. See Confluence for more details.
 */
export enum ApiErrorCode {
    UNKNOWN_ERROR = 10000,
    INVALID_USER_DATA = 10001,
    EMAIL_VERIFICATION_FAILED = 10002,
    INVALID_LOGIN_CREDENTIALS = 10003,
    INVALID_TOKEN = 10004,
    DATA_VALIDATION_FAILED = 10005,
    STORAGE_INTERNAL_ERROR = 10006,
    EXTERNAL_SERVICE_ERROR = 10008,
    PERMISSION_DENIED = 10009,
    QUESTIONNAIRE_ANSWERS_NOT_FOUND = 10010,
    INELIGIBLE_FOR_SUBSCRIPTION = 10011,
    SUBSCRIPTION_NOT_FOUND = 10012,
    SUBSCRIPTION_ITEM_NOT_FOUND = 10013,
    SUBSCRIPTION_ITEM_CANNOT_BE_ADDED = 10014,
    SUBSCRIPTION_INVALID_INTERVAL = 10015,
    PURCHASE_ITEM_NOT_FOUND_IN_PROVIDER = 10016,
    ADDRESS_NOT_FOUND = 10017,
    AVATAR_NOT_FOUND = 10018,
    INVALID_API_TOKEN = 10019,
    NO_DEFAULT_PAYMENT_METHOD = 10020,
    USER_LIFELINE_ITEM_NOT_SUPPORTED = 10021,
    USER_LIFELINE_ITEM_INVALID_STRUCTURE = 10022,
    SUBSCRIPTION_COUPON_DOES_NOT_EXIST = 10023,
    PAYMENT_METHOD_NOT_FOUND = 10024,
    MFA_REQUIRED = 10025,
    PAYMENT_CHARGE_ERROR = 10026,
    QUESTIONNAIRE_NOT_FOUND = 10027,
    QUESTIONNAIRE_ANSWERS_TYPE_INVALID = 10028,
    MFA_INVALID_TOKEN = 10029,
    MFA_INVALID_SECRET = 10030,
    EMAIL_VERIFICATION_REQUIRED = 10031,
    INTERVAL_CHANGE_NOT_ALLOWED_FOR_ONE_TIME_SUBSCRIPTION = 10032,
    SUBSCRIPTION_INVALID_STATUS_TO_BUY = 10033,
    EXTERNAL_ENTITY_NOT_FOUND = 10034,
    PATIENT_NOTE_NOT_FOUND = 10035,
    SUBSCRIPTION_COUPON_INVALID = 10036,
    REFERRAL_COUPON_NOT_EXISTS_FOR_AUTHENTICATED_USER = 10038,
    SUBSCRIPTION_REFERRAL_COUPON_NOT_FOUND_FOR_CODE = 10040,
    ILLEGAL_ITEM_QUANTITY_VALUE = 10042,
    SUBSCRIPTION_CHANGE_STATUS_FAILED = 10045,
    STATE_NOT_FOUND = 10046,
    UNABLE_TO_TRIGGER_LAB_ORDER = 10047,
    UNABLE_TO_PLACE_LAB_ORDER = 10048,
    SUBSCRIPTION_ITEM_EXPIRATION_FORBIDDEN = 10049,
    SCHEDULED_TASK_NOT_FOUND = 10050,
    USER_LIFELINE_ITEM_NOT_FOUND = 10051,
    USER_IS_NOT_SUBSCRIBED_TO_LAB_TESTS = 10052,
    NO_STANDING_LAB_ORDER_AVAILABLE = 10054,
    UNAVAILABLE_LAB_ORDER_PROVIDER = 10055,
    LAB_ORDER_NOT_FOUND = 10056,
    LAB_ORDER_PROVIDER_UPDATE_FAILED = 10057,
    EMAIL_NOT_AVAILABLE = 10058,
    PASSWORD_REUSE_NOT_ALLOWED = 10059,
    UNABLE_TO_DOCUMENT_LAB_ORDER = 10060,
    PASSWORD_EXPIRED = 10061,
    EMAIL_VERIFICATION_CODE_EXPIRED = 10062,
    MEDICATION_RENEWAL_NOT_FOUND = 10063,
    MEDICATION_RENEWAL_ERROR = 10064,
    RATE_LIMIT_EXCEEDED = 10065,
    SUBSCRIPTION_INVALID_STATUS_TO_UPDATE_ITEM = 10066,
    SUBSCRIPTION_CONCURRENT_MODIFICATION = 10067,
    STRIPE_SIGNATURE_VERIFICATION_FAILED = 20001,
    STRIPE_INVALID_DATA = 20002,
    STRIPE_UNEXPECTED_EVENT = 20003,
    TRUEPILL_INVALID_DATA = 21001,
    TRUEPILL_MISSED_CALLBACK_TYPE = 21002,
    TRUEPILL_CONSULTATION_NOT_FOUND = 21003,
    TRUEPILL_UNKNOWN_STATUS = 21004,
    TRUEPILL_PRESCRIPTION_NOT_FOUND = 21005,
    TRUEPILL_PRESCRIPTION_ALREADY_EXISTS = 21006,
    TRUEPILL_FOLLOWUP_CONSULTATION_CREATION_IMPOSSIBLE = 21008,
    TRUEPILL_CANNOT_FETCH_CLINICAL_PROTOCOL = 21009,
    DETECTED_ISSUE_INVALID = 32001,
    DETECTED_ISSUE_ALREADY_MITIGATED = 32002,
    DETECTED_ISSUE_NOT_FOUND = 32003,
    DETECTED_ISSUE_INVALID_V3_ACT_CODE = 32004,
    MITIGATION_TYPE_NOT_FOUND = 32005,
    SHIPMENT_CANCELLATION_FAILED = 32006,
    SHIPMENT_NOT_FOUND = 32007,
    SUBSCRIPTION_INVALID_STATUS_TO_REMOVE_ITEM = 32008,
    SUBSCRIPTION_INVALID_STATUS_TO_ADD_ITEM = 32009,
    PRESCRIPTION_NOT_FOUND = 32010,
    CANCEL_LAB_ORDER_FAILED = 32011,
    CANNOT_ASSIGN_PROVIDER_TO_CONSULTATION = 32012,
    PROVIDER_ALREADY_ASSIGNED_TO_CONSULTATION = 32013,
    UNASSIGNING_PROVIDER_FAILED = 32014,
    MARK_LAB_ORDER_AS_COMPLETED_FAILED = 32015,
    CANNOT_COMPLETE_CONSULTATION = 32016,
    CONSULTATION_NOT_FOUND = 32017,
    PROVIDER_NOT_FOUND = 32018,
    USER_NOT_FOUND = 32019,
    DOSESPOT_INVALID_DATA = 32020,
    DOSESPOT_CANNOT_FETCH_PHARMACIES = 32021,
    DOSESPOT_CANNOT_CREATE_OR_UPDATE_PATIENT = 32022,
    DOSESPOT_CANNOT_CREATE_OR_UPDATE_CLINICIAN = 32023,
    DOSESPOT_CANNOT_CREATE_OR_UPDATE_PATIENT_SELF_REPORTED_MEDS = 32024,
    DOSESPOT_UNKNOWN_STATUS = 32025,
    DOSESPOT_CANNOT_CREATE_OR_UPDATE_PATIENT_SELF_REPORTED_ALLERGIES = 32026,
    DOSESPOT_CANNOT_ADD_PATIENT_PRESCRIPTION = 32027,
    DOSESPOT_CANNOT_SEND_PATIENT_PRESCRIPTION = 32028,
    SUBSCRIPTION_INVALID_STATUS_TO_ADD_LAB_ITEM = 32029,
    SUBSCRIPTION_INVALID_LAB_ITEM = 32030,
    MARK_LAB_ORDER_AS_DECLINED_FAILED = 32031,
    TRUEPILL_CANNOT_CREATE_OR_UPDATE_PATIENT = 32033,
    CONSULTATION_CARE_PLAN_ACTION_CANNOT_BE_ADDED = 32037,
    INVALID_PROVIDER_TO_MODIFY_CONSULTATION = 32038,
    PRESCRIPTION_PROVIDER_SPECIFIC_INFO_NOT_FOUND = 32039,
    INVALID_NUMBER_OF_PRIMARY_BENEFITS = 32040,
    CARE_PLAN_ACTIONS_DEFINED_FOR_NOT_TAKEN_ITEMS = 32041,
    DUPLICATED_CARE_PLAN_ACTIONS_DEFINED_FOR_THE_SAME_MEDICATIONS = 32042,
    CONSULTATION_IN_PROGRESS_FOR_PATIENT = 32043,
    CANNOT_FETCH_PRESCRIPTION_DETAILS = 32044,
    FEATURE_INACTIVE = 32045,
    DOSESPOT_CANNOT_FIND_CLINICIAN_OR_PRESCRIBING_AGENT = 32046,
    DOSESPOT_CANNOT_FIND_PATIENT = 32047,
    SUBSCRIPTION_INVALID_ITEM_METADATA = 32048,
    DOSESPOT_CANNOT_FETCH_NOTIFICATIONS_COUNT = 32049,
    PHARMACY_INFORMATION_NOT_FOUND = 32050,
    ACTION_FOR_NINE_AM_MED_WITHOUT_DAYS_OF_SUPPLY = 32051,
    ACTION_FOR_NINE_AM_MED_WITHOUT_DAILY_DOSAGE = 32052,
    ACTION_FOR_ITEM_WRONG_QUANTITY = 32053,
    COULD_NOT_READ_REQUEST = 32054,
    CANNOT_REPORT_CONSULTATION_ISSUE = 32055,
    CANNOT_CANCEL_CONSULTATION = 32056,
    CONSULTATION_CANNOT_BE_MODIFIED = 32057,
    DOSESPOT_DIAGNOSIS_SEARCH_FAILED = 32058,
    ACTIONS_DEFINED_FOR_UNKNOWN_SUPPLY_NDCS = 32060,
    LAB_ORDER_UPDATE_FAILED = 32061,
    DOSESPOT_PRESCRIPTION_REFRESH_FAILED = 32062,
    ADDRESS_COORDINATES_NOT_FOUND = 32063,
    PHARMACY_INFORMATION_INVALID_ID_FORMAT = 32064,
    CONSULTATION_CANNOT_BE_CREATED_BECAUSE_OF_PENDING_ISSUES = 32065,
    CONSULTATION_REASON_ERROR = 32066,
    CANNOT_CREATE_CHANGE_HEALTHCARE_LAB_ORDER_SUMMARY_URL = 32067,
    PCP_CANNOT_BE_FOUND = 32068,
    CANNOT_STORE_LAB_ORDER_REQUISITION = 32069,
    CHANGE_HEALTHCARE_API_DATA_RECEIVED_ERROR = 32070,
    CONSULTATION_COMPLETED_LIFELINE_ITEM_ALREADY_EXISTS = 32071,
    CANNOT_FETCH_PROVIDER_INFO = 32072,
    CANNOT_CREATE_CLINICAL_SUMMARY = 32073,
    INVALID_FAX_DATA = 32074,
    FAX_SENDING_FAILED = 32075,
    GETLABS_CANNOT_PARSE_WEBHOOK = 32076,
    CANNOT_ASSIGN_CARE_TEAM_USER_TO_CONSULTATION = 32077,
    CANNOT_UNASSIGN_CARE_TEAM_USER_FROM_CONSULTATION = 32078,
    PROVIDER_NOT_ASSIGNED_TO_CONSULTATION = 32079,
    CONSULTATION_CANNOT_BE_REACTIVATED_IN_GIVEN_STATUS = 32080,
    CANNOT_DEFINE_GIVEN_ACTION_MORE_THAN_ONCE = 32081,
    SUBSCRIPTION_MOST_RECENT_PERIODIC_NOT_FOUND = 32082,
    SUBSCRIPTION_UPDATE_ITEM_EXPIRATION_DATE_FAILED = 32083,
    ILLEGAL_ITEM_INITIAL_APPLICATION_DATE_BEFORE_MEDICATION_START = 32084,
    ILLEGAL_FUTURE_ITEM_INITIAL_APPLICATION_DATE = 32085,
    ILLEGAL_ITEM_TYPE_FOR_INITIAL_APPLICATION_DATE = 32086,
    CONSULTATION_CANNOT_BE_ACTIVATED_IN_GIVEN_STATUS = 32087,
    CONSULTATION_CANNOT_BE_ACTIVATED_BECAUSE_OF_PENDING_ISSUES = 32088,
    CONSULTATION_CANNOT_BE_ACTIVATED_BECAUSE_OF_MISSING_TAKE_CONSULTATION_NOTES = 32089,
    INVALID_CARE_TEAM_TO_MODIFY_CONSULTATION = 32090,
    NO_CARE_TEAM_ASSIGNED = 32091,
    CONSULATION_NO_PROVIDER_ASSIGNED = 32092,
    UNSUPPORTED_CARE_PLAN_ACTION = 32093,
    COMPLETED_CONSULTATION_WITH_UNFINISHED_FOLLOW_UP_ACTIONS_EXISTS = 32094,
    CANNOT_COMPLETE_ORDER_ONLY_CONSULTATIONS_IN_BULK = 32095,
    CANNOT_CREATE_CONSULTATION_FOR_PATIENT_WITHOUT_MANDATORY_PROFILE_ATTRIBUTES = 32096,
    CANNOT_CREATE_CONSULTATION_FOR_PATIENT_WITHOUT_ACTIVE_SUBSCRIPTION = 32097,
    TASKS_TASK_NOT_FOUND = 33001,
    TASKS_TASK_STATUS_UPDATE_NOT_ALLOWED = 33002,
    MESSAGING_MESSAGE_NOT_FOUND = 33101,
    SMS_AWS_CANNOT_PARSE_WEBHOOK = 33200,
    SMS_AWS_UNKNOWN_NOTIFICATION_TYPE = 33201,
    SMS_PHONE_NUMBER_NOT_FOUND_FOR_USER = 33202,
    SMS_PHONE_NUMBER_ALREADY_VERIFIED_FOR_USER = 33203,
    SMS_MISSING_PHONE_NUMBER_VERIFICATION_NOTE = 33204,
    FILE_NOT_FOUND = 33301,
    FILE_NOT_AVAILABLE = 33302,
    UNSUPPORTED_FILE_TYPE = 33303,
    FILE_TOO_LARGE = 33304,
    CUSTOMERIO_INVALID_REQUEST_DATA = 33400,
    CUSTOMERIO_INVALID_SIGNATURE = 33401,
    CUSTOMERIO_INVALID_SIGNATURE_CONFIGURATION = 33402,
    CUSTOMERIO_USER_NOT_FOUND = 33403,
    CUSTOMERIO_COULD_NOT_READ_MESSAGE = 33404,
    BENEFITS_MEDICATION_PRIOR_AUTHORIZATION_NOT_FOUND = 33500,
    BENEFITS_INVALID_MEDICATION_PRIOR_AUTHORIZATION_TYPE_TO_ADD_APPEAL = 33501,
    BENEFITS_INVALID_MEDICATION_PRIOR_AUTHORIZATION_STATUS_TO_ADD_APPEAL = 33502,
    BENEFITS_APPEAL_LIMIT_FOR_MEDICATION_PRIOR_AUTHORIZATION_EXCEEDED = 33503,
    BENEFITS_TERMINAL_FOR_MEDICATION_PRIOR_AUTHORIZATION_CANT_BE_CHANGED = 33504,
    BENEFITS_VALID_UNTIL_DATE_FOR_MEDICATION_PRIOR_AUTHORIZATION_STATUS_CHANGE_IS_REQUIRED = 33505,
    BENEFITS_MEDICATION_NOT_FOUND_FOR_MEDICATION_PRIOR_AUTHORIZATION = 33506,
    BENEFITS_EMPTY_MEDICATION_PROVIDED_FOR_MEDICATION_PRIOR_AUTHORIZATION = 33507,
    BENEFITS_EMPTY_APPEAL_FOR_AND_MEDICATION_PROVIDED_FOR_MEDICATION_PRIOR_AUTHORIZATION = 33508,
    BENEFITS_INVALID_MEDICATION_PRIOR_AUTHORIZATION_INITIAL_STATUS = 33509,
    BENEFITS_BENEFIT_EXISTS = 33510,
    BENEFITS_BENEFIT_DOES_NOT_EXIST = 33511,
    DEVICE_NOT_FOUND = 33601,
    DEVICE_IN_USE = 33602,
    DEVICE_INVALID_DATA = 33603,
    SMARTMETERRPM_INVALID_DATA = 33701,
    SMARTMETERRPM_INVALID_SIGNATURE = 33702,
    SMARTMETERRPM_INVALID_SIGNATURE_CONFIGURATION = 33703,
    LILLY_USER_NOT_FOUND = 33801,
    LILLY_PATIENT_NOT_FOUND = 33802,
    LILLY_INSUFFICIENT_DATA = 33803,
    USER_LIFELINE_ITEM_DELETED = 33901,
    USER_LIFELINE_ITEM_DELETE_NOT_PERMITTED = 33902,
    QUESTIONNAIRE_SESSION_NOT_FOUND = 34001,
    QUESTIONNAIRE_SESSION_COMPLETED = 34002,
    QUESTIONNAIRE_VARIABLE_PROVIDER_FAILED_DUE_TO_PROVIDER_SPECIFIC_ERROR = 34003,
    QUESTIONNAIRE_SESSION_NOT_AVAILABLE = 34004,
    ELIGIBILITY_COULD_NOT_BE_CHECKED = 34100,
    ELIGIBILITY_CHECK_FAILED_DUE_TO_TECH_ERROR = 34101,
    PARTNER_INELIGIBLE_FOR_SUBSCRIPTION = 34102,
    EMPLOYER_NOT_COVERED_BY_PLAN = 34103,
    EMPLOYER_REQUIRED_BY_PLAN = 34104,
    SFTP_TO_GO_INVALID_DATA = 34200,
    SFTP_TO_GO_INVALID_SIGNATURE = 34201,
    SFTP_TO_GO_INVALID_SIGNATURE_CONFIGURATION = 34202,
    CONNECTIVE_HEALTH_NO_PATIENT_PROCESSING = 34300,
    CONNECTIVE_HEALTH_PROCESSING_REQUESTED_TOO_SOON = 34301,
    CONNECTIVE_HEALTH_FAILED_INCOMPLETE_PATIENT_DATA = 34302,
    CONNECTIVE_HEALTH_FAILED_INVALID_PATIENT_DATA = 34303,
    SHIPMENT_CANNOT_BE_INITIATED = 34401,
    SHIPMENT_STATUS_UPDATE_NOT_ALLOWED = 34402,
    SHIPMENT_CANCELLATION_NOT_SUPPORTED = 34403,
    CONSENT_DOCUMENT_NOT_FOUND = 34501,
    DIAGNOSIS_ALREADY_EXIST = 34601,
    DIAGNOSIS_PATIENT_HAS_CONSULTATION_ONGOING = 34602,
    ZENDESK_UNSUPPORTED_WEBHOOK = 34701,
    FEEDBACK_HAS_BEEN_PROVIDED = 34801,
    AI_MISSING_DATA = 34802,
    AI_INTERNAL_ERROR = 34803,
    AI_INVALID_INPUT_PROVIDED = 34804,
    PHARMACY_BENEFIT_UNKNOWN_PARTNER_ID = 34900,
    RXDIET_USER_ALREADY_EXISTS = 34901,
    RXDIET_USER_CREDENTIALS_NOT_FOUND = 34902,
    RXDIET_CANNOT_CREATE_USER = 34903,
    RXDIET_USER_NOT_FOUND = 34904,
    SUBSCRIPTION_INVALID_STATUS_TO_FINISH = 35000,
    SUBSCRIPTION_INVALID_STATUS_TO_REACTIVATE = 35001,
    SUBSCRIPTION_PLAN_NOT_FOUND = 35002,
    INITIAL_SUBSCRIPTION_NOT_FOUND = 35003,
    SUBSCRIPTION_CANNOT_BE_PAUSED = 35004,
    SUBSCRIPTION_CANNOT_BE_UNPAUSED = 35005,
    SUBSCRIPTION_RECURRING_PAYMENT_ALREADY_ACTIVE = 35006,
    INVALID_MEDICATION_ITEM_FOR_INITIAL_APPLICATION_DATE = 35007,
    SUBSCRIPTION_PLAN_NOT_ALLOWED = 35008,
    SUBSCRIPTION_PLAN_CHANGE_NOT_ALLOWED = 35009,
    RPM_STATUS_NOT_AVAILABLE = 35100,
    CONCIERGE_CARE_NOT_AVAILABLE_FOR_EMPLOYER = 35101,
    MEDICATION_CONTINUATION_ERROR = 35102,
    APPOINTMENT_NOT_FOUND = 35200,
    APPOINTMENT_CANNOT_BE_RESCHEDULED = 35201,
    PROSPECTIVE_APPOINTMENT_CANNOT_BE_CREATED = 35202,
    PROSPECTIVE_APPOINTMENT_CANNOT_BE_CANCELED = 35203,
    APPOINTMENT_SCHEDULING_CONFLICT = 35204,
    APPOINTMENT_PARTICIPANTS_NOT_FOUND = 35205,
    APPOINTMENT_LIMIT_EXCEEDED = 35206,
    APPOINTMENT_INVALID_DATA = 35207,
    APPOINTMENT_SCHEDULING_PRECONDITION_NOT_FULFILLED = 35208,
    APPOINTMENT_TYPE_DEPRECATED = 35209,
    APPOINTMENT_VIDEO_CALL_IN_PROGRESS = 35210,
    OBSERVATION_INVALID_DATE_RANGE = 35300,
    OBSERVATION_INVALID_DATE = 35301,
    CANNOT_FIND_OBSERVATION_BUNDLE = 35302,
    ALLERGY_INTOLERANCE_ALREADY_EXIST = 35401,
    ALLERGY_INTOLERANCE_NOT_FOUND = 35402,
    TREATMENTPLAN_UNKNOWN_TARGET = 35501,
    PRESCRIPTION_MEDICATION_NOT_FOUND = 35601,
    INTAKE_LOG_NOT_FOUND = 35602,
    LAST_INTAKE_DATE_BEFORE_PRESCRIPTION = 35603,
    ZOOM_WEBHOOK_VERIFICATION_FAILED = 35701,
    MESSAGE_DRAFT_NOT_FOUND = 35801,
    MESSAGE_DRAFT_MISSING_INPUT_DATA = 35802,
    MESSAGE_DRAFT_NOT_ALLOWED = 35803,
    CANNOT_GENERATE_INSIGHTS = 35901,
    INSIGHTS_NOT_FOUND = 35902,
    INSIGHT_REFINEMENT_SUPERSEDED = 35903,
    SOLERA_API_REQUEST_FAILED = 36001,
    SOLERA_NO_USER_FOUND = 36002,
    NOT_READY_FOR_DELETION = 36101,
    WITHINGS_ORDER_NOT_FOUND = 36201,
    WITHINGS_SUPPORTED_DEVICE_NOT_FOUND = 36202,
    WITHINGS_API_ERROR = 36203,
    WITHINGS_TOKEN_NOT_FOUND = 36204,
    WITHINGS_DEVICE_LINK_CONFLICT = 36205,
    CONVERSATION_NOT_FOUND = 36301,
    CONVERSATION_MESSAGE_NOT_FOUND = 36302,
    CONVERSATION_CLOSED = 36303,
    CONVERSATION_ALREADY_ESCALATED = 36304,
    ESCALATION_NOT_FOUND = 36305,
    CONVERSATION_MISSION_NOT_FOUND = 36306,
    CONVERSATION_MISSION_NOT_ACTIVE = 36307,
    CONVERSATION_MISSION_NO_ACTIVE_SUBSCRIPTION = 36308,
    TAKE_CONSULTATION_NOTES_ACTION_NOT_DEFINED_FOR_SYNC_CONSULT = 36401,
    CANNOT_CREATE_CONSULTATION_FOR_PEDIATRIC_PATIENT_WITH_MISSING_ATTRIBUTES = 36402,
    CONSULTATION_CANNOT_CREATE_LIFELINE_ITEM_FOR_NOT_COMPLETED_CONSULTATION = 36403,
    CONSULTATION_CANNOT_GENERATE_LIFELINE_ITEM_FOR_NOT_ACTIVE_CONSULTATION = 36404,
    WEBSOCKET_EMPTY_PAYLOAD = 36501,
    CONSISTENCY_SCORE_NOT_FOUND = 37101,
    LAB_AUTO_EXTRACTION_NOT_FOUND = 38001,
    LAB_ORDER_REVIEW_NOT_FOUND = 38002,
    KNOWLEDGE_DOCUMENT_NOT_FOUND = 38101,
    KNOWLEDGE_DOCUMENT_INVALID_METADATA = 38102,
    KNOWLEDGE_SEARCH_API_KEY_NOT_CONFIGURED = 38103,
    KNOWLEDGE_SEARCH_PAGE_OUT_OF_RANGE = 38104,
    MACRO_NOT_FOUND = 38201,
    NOTIFICATION_MESSAGE_NOT_FOUND = 39001,
    LYRA_CONSENT_INACTIVE = 40001,
    LYRA_PATIENT_DATA_NOT_FOUND = 40002,
    PROVIDER_ALREADY_EXISTS_FOR_USER = 40101,
    PROVIDER_NPI_IN_USE = 40102,
    CLINICAL_EXCEPTION_PAYER_REQUIRED = 40201,
    CLINICAL_EXCEPTION_PAYER_UNSUPPORTED = 40202,
    CLINICAL_EXCEPTION_NO_QUALIFYING_CONDITION_FOUND = 40203,
    CASES_CASE_NOT_FOUND = 41001,
    CASES_VIEW_NOT_FOUND = 41002,
    CASES_GROUP_NOT_FOUND = 41003,
    CASES_GROUP_NOT_EMPTY = 41004,
    CASES_ASSIGNEE_NOT_IN_GROUP = 41005,
    CASES_VIEW_INVALID_FILTER = 41006,
    CASES_VIEW_NAME_CONFLICT = 41007,
    CASES_GROUP_NAME_CONFLICT = 41008,
    CASES_TAG_NAME_CONFLICT = 41009,
    CASES_DEFAULT_GROUP_DELETION = 41010,
    CASES_DEFAULT_GROUP_NOT_CONFIGURED = 41011,
    CASES_TAG_NOT_FOUND = 41012,
    CASES_INVALID_LINK = 41013,
    CASES_ASSIGNMENT_REQUIRED = 41014,
    CASES_KNOWN_GROUP_DELETION = 41015,
    CASES_LOCKED_BY_ANOTHER_USER = 41016,
    CASES_VIEW_INVALID_ROLE = 41017,
    CASES_GROUP_REFERENCED_BY_VIEW = 41018,
    CASES_DETAILS_IDENTITY_MISMATCH = 41019,
    CASES_DETAILS_UPDATE_UNSUPPORTED_FOR_TYPE = 41020,
    CASES_DETAILS_MALFORMED = 41021,
    CASES_INVALID_APPOINTMENT = 41022,
    CASES_WITHOUT_MEMBER = 41023,
    CASES_CONVERSATION_MISMATCH = 41024,
    CASES_CONVERSATION_ESCALATED_ELSEWHERE = 41025,
    CASES_CLOSED = 41026,
    CASES_MANAGEMENT_DISABLED = 41027,
    CASES_USER_ALREADY_CONNECTED = 41028,
    CASES_USER_NOT_FOUND = 41029,
    CASES_USER_CONNECT_REJECTED = 41030,
    REMINDER_NOT_FOUND = 41101,
    TRANSCARENT_MEMBER_ID_ALREADY_LINKED = 43001,
    TRANSCARENT_MEMBER_LINK_NOT_FOUND = 43002,
    EXTERNAL_IDENTITY_NOT_FOUND = 44001,
    EXTERNAL_IDENTITY_ALREADY_LINKED = 44002,
    EXTERNAL_IDENTITY_INVALID = 44003,
    EXTERNAL_IDENTITY_SYSTEM_UNAVAILABLE = 44004,
    EXTERNAL_IDENTITY_UNLINK_UNSUPPORTED = 44005,
    EXTERNAL_IDENTITY_OPERATION_UNSUPPORTED = 44006,
    EXTERNAL_IDENTITY_LINKED_TO_ANOTHER_USER = 44007,
    SIMULATED_DATA_ALREADY_EXISTS = 45001,
    USER_DEACTIVATED = 47001,
}
